import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MenuMobileSVG } from '../../assets';
import IconButton from '../IconButton';
import { SoundPillMark } from '../header/draft/SoundPillMark';
import { AppInstallNudge } from './AppInstallNudge';

type MobileSiteHeaderProps = {
  onMenuOpen: () => void;
};

/** lg 미만 — Draft SiteHeader: 설치 넛지 + 모바일 헤더 바 (fixed) */
export function MobileSiteHeader({ onMenuOpen }: MobileSiteHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="soundpill-mobile-site-header fixed top-0 left-0 right-0 z-50 lg:hidden flex flex-col w-full">
      <AppInstallNudge />
      <header className="soundpill-mobile-site-header__bar px-4 flex justify-between items-center w-full min-h-[var(--mobile-header-bar-height)] gap-2 bg-[#1e1e26]/90 backdrop-blur-md border-b border-[#464555]/50 shrink-0">
        <Link
          to="/app/home"
          className="flex items-center min-w-0 shrink-0 no-underline"
          aria-label={t('header.soundpill')}
        >
          <SoundPillMark />
          <span
            className="ml-[11px] text-[20px] leading-none font-semibold whitespace-nowrap not-italic truncate"
            style={{ letterSpacing: '-0.72px', color: '#E5E2E3' }}
          >
            {t('header.soundpill')}
          </span>
        </Link>
        <div className="flex gap-2 shrink-0">
          <IconButton onClick={onMenuOpen}>
            <MenuMobileSVG />
          </IconButton>
        </div>
      </header>
    </div>
  );
}
